import request from '@/helpers/request'

export default {
  async index() {
    return await request.get('melontv')
  },
  async show(melontvId) {
    return await request.get('melontv/' + melontvId)
  },
  async list() {
    return await request.get('melontv-list')
  },
  async search(time) {
    return await request.get('melontv-search?searchTime=' + time)
  },
  async searchDay(time) {
    return await request.get('melontv-search?searchDay=' + time)
  },
  async searchClass(classCategory) {
    return await request.get('melontv-search?searchCategory=' + classCategory)
  },
  async searchInstructor(instructorName) {
    return await request.get('melontv-search?searchInstructor=' + instructorName)
  }
}
